import TS_5_Updates from "./typescript_components/TS_5_Updates.jsx";
import TS_Advanced_Types from "./typescript_components/TS_Advanced_Types.jsx";
import TS_Aliases_Interfaces from "./typescript_components/TS_Aliases_Interfaces.jsx";
import TS_Arrays from "./typescript_components/TS_Arrays.jsx";
import TS_Async_Programming from "./typescript_components/TS_Async_Programming.jsx";
import TS_Basic_Generics from "./typescript_components/TS_Basic_Generics.jsx";
import TS_Best_Practices from "./typescript_components/TS_Best_Practices.jsx";
import TS_Casting from "./typescript_components/TS_Casting.jsx";
import TS_Certificate from "./typescript_components/TS_Certificate.jsx";
import TS_Classes from "./typescript_components/TS_Classes.jsx";
import TS_Conditional_Types from "./typescript_components/TS_Conditional_Types.jsx";
import TS_Configuration from "./typescript_components/TS_Configuration.jsx";
import TS_Declaration_Merging from "./typescript_components/TS_Declaration_Merging.jsx";
import TS_Decorators from "./typescript_components/TS_Decorators.jsx";
import TS_Definitely_Typed from "./typescript_components/TS_Definitely_Typed.jsx";
import TS_Editor from "./typescript_components/TS_Editor.jsx";
import TS_Enums from "./typescript_components/TS_Enums.jsx";
import TS_Error_Handling from "./typescript_components/TS_Error_Handling.jsx";
import TS_Exercises from "./typescript_components/TS_Exercises.jsx";
import TS_Explicit_Inference from "./typescript_components/TS_Explicit_Inference.jsx";
import TS_Functions from "./typescript_components/TS_Functions.jsx";
import TS_Get_Started from "./typescript_components/TS_Get_Started.jsx";
import TS_Home from "./typescript_components/TS_Home.jsx";
import TS_Index_Signatures from "./typescript_components/TS_Index_Signatures.jsx";
import TS_Introduction from "./typescript_components/TS_Introduction.jsx";
import TS_JS_Projects from "./typescript_components/TS_JS_Projects.jsx";
import TS_Keyof from "./typescript_components/TS_Keyof.jsx";
import TS_Literal_Types from "./typescript_components/TS_Literal_Types.jsx";
import TS_Mapped_Types from "./typescript_components/TS_Mapped_Types.jsx";
import TS_Migration from "./typescript_components/TS_Migration.jsx";
import TS_Namespaces from "./typescript_components/TS_Namespaces.jsx";
import TS_NodeJS from "./typescript_components/TS_NodeJS.jsx";
import TS_Null from "./typescript_components/TS_Null.jsx";
import TS_Object_Types from "./typescript_components/TS_Object_Types.jsx";
import TS_Quiz from "./typescript_components/TS_Quiz.jsx";
import TS_React from "./typescript_components/TS_React.jsx";
import TS_Simple_Types from "./typescript_components/TS_Simple_Types.jsx";
import TS_Special_Types from "./typescript_components/TS_Special_Types.jsx";
import TS_Study_Plan from "./typescript_components/TS_Study_Plan.jsx";
import TS_Syllabus from "./typescript_components/TS_Syllabus.jsx";
import TS_Tooling from "./typescript_components/TS_Tooling.jsx";
import TS_Tuples from "./typescript_components/TS_Tuples.jsx";
import TS_Type_Guards from "./typescript_components/TS_Type_Guards.jsx";
import TS_Type_Inference from "./typescript_components/TS_Type_Inference.jsx";
import TS_Union_Types from "./typescript_components/TS_Union_Types.jsx";
import TS_Utility_Types from "./typescript_components/TS_Utility_Types.jsx";

const typeScriptComponentsMap = {
  "<TS_5_Updates />": TS_5_Updates,
  "<TS_Advanced_Types />": TS_Advanced_Types,
  "<TS_Aliases_Interfaces />": TS_Aliases_Interfaces,
  "<TS_Arrays />": TS_Arrays,
  "<TS_Async_Programming />": TS_Async_Programming,
  "<TS_Basic_Generics />": TS_Basic_Generics,
  "<TS_Best_Practices />": TS_Best_Practices,
  "<TS_Casting />": TS_Casting,
  "<TS_Certificate />": TS_Certificate,
  "<TS_Classes />": TS_Classes,
  "<TS_Conditional_Types />": TS_Conditional_Types,
  "<TS_Configuration />": TS_Configuration,
  "<TS_Declaration_Merging />": TS_Declaration_Merging,
  "<TS_Decorators />": TS_Decorators,
  "<TS_Definitely_Typed />": TS_Definitely_Typed,
  "<TS_Editor />": TS_Editor,
  "<TS_Enums />": TS_Enums,
  "<TS_Error_Handling />": TS_Error_Handling,
  "<TS_Exercises />": TS_Exercises,
  "<TS_Explicit_Inference />": TS_Explicit_Inference,
  "<TS_Functions />": TS_Functions,
  "<TS_Get_Started />": TS_Get_Started,
  "<TS_Home />": TS_Home,
  "<TS_Index_Signatures />": TS_Index_Signatures,
  "<TS_Introduction />": TS_Introduction,
  "<TS_JS_Projects />": TS_JS_Projects,
  "<TS_Keyof />": TS_Keyof,
  "<TS_Literal_Types />": TS_Literal_Types,
  "<TS_Mapped_Types />": TS_Mapped_Types,
  "<TS_Migration />": TS_Migration,
  "<TS_Namespaces />": TS_Namespaces,
  "<TS_NodeJS />": TS_NodeJS,
  "<TS_Null />": TS_Null,
  "<TS_Object_Types />": TS_Object_Types,
  "<TS_Quiz />": TS_Quiz,
  "<TS_React />": TS_React,
  "<TS_Simple_Types />": TS_Simple_Types,
  "<TS_Special_Types />": TS_Special_Types,
  "<TS_Study_Plan />": TS_Study_Plan,
  "<TS_Syllabus />": TS_Syllabus,
  "<TS_Tooling />": TS_Tooling,
  "<TS_Tuples />": TS_Tuples,
  "<TS_Type_Guards />": TS_Type_Guards,
  "<TS_Type_Inference />": TS_Type_Inference,
  "<TS_Union_Types />": TS_Union_Types,
  "<TS_Utility_Types />": TS_Utility_Types,
};

export default typeScriptComponentsMap;
